export default function MegaphoneIcon({ className = '' }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.92.55 1.821.887 2.787a11.848 11.848 0 003.428-4.565M12.91 6.85c.063.8.127 1.6.127 2.4 0 3.241 0 6.463-.415 9.595-1.274a11.846 11.846 0 003.428-4.565" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l-4.5 4.5" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l4.5-4.5" />
    </svg>
  );
}
